module.exports = __webpack_public_path__ + "01_long_grey.0131ffb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/01_long_grey.png
// module id = JU/G
// module chunks = 0